import axios from "axios";
import authHeader from '../../../authheader'

const PEREINSTATEMENTURL = process.env.REACT_APP_APIURL + "/api/IndividualPeReinstatement";

const getContactInformation = (reinstatementId) => {
    return axios.get(`${PEREINSTATEMENTURL}/contactinformation`, { headers: authHeader(), params: { reinstatementId } });
}
export default {
    getContactInformation
}